// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SNii","name":"styles_name__2Nesc","phone":"styles_phone__NSxZb"};